import { rem } from 'polished';
import styled from 'styled-components/macro';

export const StyledSplitWrapper = styled.div`
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    display: grid;
    grid-template-columns: calc(50% - ${rem('30px')}) calc(50% - ${rem('30px')});
    gap: ${rem('60px')};
  }
`;
